export default "__VITE_ASSET__81da1b56__"